"use strict";

var SQUARE_WEDDING_PROGRAMS = 'Square Wedding Programs';
var SQUARE_WEDDING_PROGRAM_REPRINTS = 'Square Wedding Program Reprints';
var FLAT_BOOKLET_WEDDING_PROGRAMS = 'Flat Booklet Wedding Programs';
var FLAT_WEDDING_PROGRAMS = 'Flat Wedding Programs';
var FLAT_BOOKLET_WEDDING_PROGRAM_REPRINTS = 'Flat Booklet Wedding Program Reprints';
var FLAT_WEDDING_PROGRAM_REPRINTS = 'Flat Wedding Program Reprints';
var DELUXE_BOOKLET_WEDDING_PROGRAMS = 'Deluxe Booklet Wedding Programs';
var DELUXE_BOOKLET_WEDDING_PROGRAM_REPRINTS = 'Deluxe Booklet Wedding Program Reprints';
var BASIC_BOOKLET_WEDDING_PROGRAMS = 'Basic Booklet Wedding Programs';
var BASIC_BOOKLET_WEDDING_PROGRAM_REPRINTS = 'Basic Booklet Wedding Program Reprints';
module.exports = {
  SQUARE_WEDDING_PROGRAMS: SQUARE_WEDDING_PROGRAMS,
  SQUARE_WEDDING_PROGRAM_REPRINTS: SQUARE_WEDDING_PROGRAM_REPRINTS,
  FLAT_BOOKLET_WEDDING_PROGRAMS: FLAT_BOOKLET_WEDDING_PROGRAMS,
  FLAT_BOOKLET_WEDDING_PROGRAM_REPRINTS: FLAT_BOOKLET_WEDDING_PROGRAM_REPRINTS,
  DELUXE_BOOKLET_WEDDING_PROGRAMS: DELUXE_BOOKLET_WEDDING_PROGRAMS,
  DELUXE_BOOKLET_WEDDING_PROGRAM_REPRINTS: DELUXE_BOOKLET_WEDDING_PROGRAM_REPRINTS,
  BASIC_BOOKLET_WEDDING_PROGRAMS: BASIC_BOOKLET_WEDDING_PROGRAMS,
  BASIC_BOOKLET_WEDDING_PROGRAM_REPRINTS: BASIC_BOOKLET_WEDDING_PROGRAM_REPRINTS,
  FLAT_WEDDING_PROGRAMS: FLAT_WEDDING_PROGRAMS,
  FLAT_WEDDING_PROGRAM_REPRINTS: FLAT_WEDDING_PROGRAM_REPRINTS
};